import { styled } from "@mui/material/styles"
import { Grid } from "@mui/material"

const GridCell = styled(Grid)({
  display: "inline-flex",
  alignSelf: "center",
  justifyContent: "flex-end",
  lineHeight: "normal",
  textAlign: "right",

  "&.label": {
    justifyContent: "flex-start",
    textAlign: "left",
    marginRight: "16px",
  },
})

export default GridCell
